import { Component, ElementRef, ViewChild } from "@angular/core";
import { PreviewItemFilterOptionComponent } from "../preview-item-filter-option.component";

@Component({
    imports: [],
    templateUrl: "./preview-item-filter-option-select.component.html"
})
export class PreviewItemFilterOptionSelectComponent extends PreviewItemFilterOptionComponent {
    @ViewChild("selfSelect") private selfSelectRef!: ElementRef<HTMLSelectElement>;

    public constructor() {
        super();
    }

    public override loadStoredOptionValue(value: string): void {
        super.loadStoredOptionValue(value);
        this.trySetSelectedOption(this.selfSelectRef.nativeElement, value);
    }
}